import React, { useContext } from 'react';
import './FacilityReports.css';
import ModuleLoadingStatus from '../ModuleLoadingStatus/ModuleLoadingStatus';
import { CardReportsContext } from '../../contexts/CardReportsContext';
import logComponent from '../../common/logComponent';

export default function FacilityReportLoadingStatus({ reloadAction }) {
  const cardReportsContext = useContext(CardReportsContext);
  const { facilityReportLoading, facilityReportError } = cardReportsContext;

  if (logComponent('FacilityReportLoadingStatus')) { console.debug('FacilityReportLoadingStatus rendered'); }


  return (
    <ModuleLoadingStatus isLoading={facilityReportLoading} isError={facilityReportError} reloadAction={reloadAction} />
  );
}